import { trackEvent, updateTrackingBaseLayer } from "../../../../common-deprecated/utils/tracking";
import {
    type ComponentType,
    COMPONENT_EQUIPMENT_STANDARD,
    COMPONENT_EQUIPMENT_OPTIONAL,
} from "../../../../shared-logic/server/components";

export const getEquipmentComponentName = (component: ComponentType): string => {
    if (component === COMPONENT_EQUIPMENT_STANDARD) return "standard-equipment";
    if (component === COMPONENT_EQUIPMENT_OPTIONAL) return "accessories";
    return "";
};

export const updateTrackingLayerVersioning = (): void => {
    updateTrackingBaseLayer({
        page: {
            ...((window.tngaDataLayer?.page as Record<string, unknown>) || {}),
            versions: {
                ...((window.tngaDataLayer?.page?.versions as Record<string, unknown>) || {}),
                "dxp-webcarconfig": commithash,
            },
        },
    });
};

export const trackCustomizeLink = (componentName: ComponentType): void => {
    trackEvent({
        name: "ctaevent",
        component: getEquipmentComponentName(componentName),
        group: "new-cars",
        action: "click-cta",
        label: "carconfigurator",
    });
};

export const trackToggleExpandedEquipment = (
    componentName: ComponentType,
    label: string,
    viewMore: boolean = true,
): void => {
    trackEvent({
        name: "componentevent",
        component: getEquipmentComponentName(componentName),
        group: "new-cars",
        action: viewMore ? "view-more" : "view-less",
        label,
    });
};

export const trackEquipmentDescriptionToggle = (
    componentName: ComponentType,
    categoryId: string,
    categoryName: string,
    equipmentId: string,
    equipmentName: string,
): void => {
    trackEvent(
        {
            component: getEquipmentComponentName(componentName),
            group: "new-cars",
            action: "view-equipment",
            label: `${categoryName} : ${equipmentName}`,
        },
        null,
        componentName === COMPONENT_EQUIPMENT_OPTIONAL
            ? {
                  accessoryCategoryId: categoryId,
                  accessoryId: equipmentId,
              }
            : undefined,
    );
};
